import { Link } from 'react-router-dom';
import { ChevronRight, Home } from 'lucide-react';

/**
 * Breadcrumbs Component
 * Renders visual hierarchy breadcrumbs and returns JSON-LD BreadcrumbList object.
 */
export function getBreadcrumbSchema(items) {
  return {
    "@context": "https://schema.org",
    "@type": "BreadcrumbList",
    "itemListElement": items.map((item, index) => ({
      "@type": "ListItem",
      "position": index + 1,
      "name": item.label,
      "item": item.url ? `https://print.inchpaper.com${item.url}` : "https://print.inchpaper.com"
    }))
  };
}

export default function Breadcrumbs({ items = [] }) {
  const allItems = [
    { label: 'Home', url: '/' },
    ...items
  ];

  return (
    <nav aria-label="Breadcrumb" className="my-3 py-2 text-xs sm:text-sm text-slate-600">
      <ol className="flex flex-wrap items-center gap-1.5 list-none p-0 m-0">
        {allItems.map((item, idx) => {
          const isLast = idx === allItems.length - 1;
          return (
            <li key={`crumb-${idx}`} className="inline-flex items-center gap-1.5">
              {idx > 0 && <ChevronRight className="w-3.5 h-3.5 text-slate-400 flex-shrink-0" />}
              {isLast ? (
                <span className="font-semibold text-slate-900 truncate max-w-[200px] sm:max-w-none" aria-current="page">
                  {item.label}
                </span>
              ) : (
                <Link
                  to={item.url || '/'}
                  className="inline-flex items-center gap-1 hover:text-red-700 transition-colors"
                >
                  {idx === 0 && <Home className="w-3.5 h-3.5 text-slate-500" />}
                  <span>{item.label}</span>
                </Link>
              )}
            </li>
          );
        })}
      </ol>
    </nav>
  );
}
